// src\stores\reducers\todos.ts
// import { CONNECT_WALLET } from './../../constants';
// import { IWallet } from './../types'



// const wallet = (state: IWallet = {connected: 0}, action: { type: string; value: any }) => {
//   switch (action.type) {
//     case CONNECT_WALLET:
//       return  {
//         ...state,
//         ...action.value
//       };
//     default:
//       return state;
//   }
// };

// export default wallet;

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CONNECT_WALLET } from './../../constants';
import { ISide } from './../types';


const initialState: ISide = {
  show: false
};

const sideSlice = createSlice({
  name: 'side',
  initialState,
  reducers: {
    toggleSide: (state, action: PayloadAction<ISide>) => {
      state.show = action.payload.show;
    }
  }
});

export const { toggleSide } = sideSlice.actions;

export default sideSlice;